module.exports = __webpack_public_path__ + "img/part4-3.e6abd01a.png";